import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';
import { marketingCampaignsQueryKey } from 'src/app/queries/marketing/get-campaigns';

import type { GridValidRowModel } from '@mui/x-data-grid-pro';
import type { UseQueryOptions } from '@tanstack/react-query';

const GET_CAMPAIGN_EMAIL_RECIPIENTS = 'api/marketing-campaign/get-email-campaign-audience';

export type EmailRecipient = GridValidRowModel & {
  BouncedUtc: string | null;
  ClickedUtc: string | null;
  CustomerId: number;
  DeferredUtc: string | null;
  DeliveredUtc: string | null;
  DroppedUtc: string | null;
  Email: string;
  FirstName: string;
  LastName: string;
  OpenedUtc: string | null;
  ProcessedUtc: string | null;
  SpamReportedUtc: string | null;
  UnsubscribedUtc: string | null;
};

type CampaignEmailRecipientsResponse = {
  Data: EmailRecipient[];
  Page: number;
  TotalPages: number;
  TotalRows: number;
};

type CampaignEmailRecipientsQueryParams = {
  currentPage: number;
  endDate?: string;
  marketingCampaignId: string;
  pageSize: number;
  searchTerm?: string;
  sortAscending: boolean;
  sortColumn: string;
  startDate?: string;
};

export function useCampaignEmailRecipientsQuery(
  params: CampaignEmailRecipientsQueryParams,
  options: UseQueryOptions<CampaignEmailRecipientsResponse> = { enabled: true }
) {
  options.enabled = options.enabled && Boolean(params.marketingCampaignId && params.marketingCampaignId !== '0');

  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'email-recipients', params],
    queryFn: async () =>
      fetchData<CampaignEmailRecipientsResponse>(
        GET_CAMPAIGN_EMAIL_RECIPIENTS,
        {
          MarketingCampaignId: parseInt(params.marketingCampaignId, 10),
          CurrentPage: params.currentPage,
          PageSize: params.pageSize,
          SearchTerm: params.searchTerm ?? '',
          SortAscending: params.sortAscending,
          SortColumn: params.sortColumn,
          StartDate: params.startDate,
          EndDate: params.endDate,
        },
        {
          error: { args: { message: 'Failed to fetch campaign email recipients.' } },
        }
      ),
    ...options,
  });
}
